import { useState, useEffect, useContext } from "react";
import Indenttrack from "./Indenttrack";
import { Urls } from "../../Urls";
import Loader from "../Loader";
import ReactGA from "react-ga4";
import mixpanel from "mixpanel-browser";
import { UserApiContext } from "../UserDetailsContext/UserDetailsContext";
import { useIndentTracking } from "./hooks/useIndentTracking";

const IndentTrackingMain = (props) => {
  const [show, setshow] = useState(false);
  const [details, setdetails] = useState([]);
  const [filtered_details, setfiltered_details] = useState([]);
  const { userDetails } = useContext(UserApiContext);

  const { trackIndentEvent } = useIndentTracking();

  //Useeffect to check the policy
  useEffect(() => {
    document.title = "LoRRI Indent - Indent Tracking";
    ReactGA.send("LoRRI Indent - Indent Tracking");

    trackIndentEvent("indent tracking", "user has viewed on indent tracking page")

  }, [userDetails]);

  return (
    <div>
      <Loader show={show} />
      <div style={{ width: "100%" }} id="newindent">
        <Indenttrack
          show={show}
          setshow={setshow}
          filtered_details={filtered_details}
          setfiltered_details={setfiltered_details}
          details={details}
          setdetails={setdetails}
        />
      </div>
    </div>
  );
};

export default IndentTrackingMain;
